import React from 'react'

import { App } from '~/navigation'

export const Page: React.FC = () => <App />
